import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IotDevicesComponent } from './iot-devices/iot-devices.component';
import { IotCreateDevicesComponent } from './iot-create-devices/iot-create-devices.component';
import { IotCommunicationHistoryComponent } from './iot-communication-history/iot-communication-history.component';

const routes: Routes = [
  { path: 'iotDevices', component: IotDevicesComponent },
  { path: 'iotDevices/createDevices', component: IotCreateDevicesComponent },
  { path: 'iotDevices/communicationHistory', component: IotCommunicationHistoryComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IotDevicesRoutingModule { }
